import React from 'react';
import { arExtra, visaBeteckning } from '../../../../utils/offertSpar';

/**
 * StatusMessages - Visar status-relaterade meddelanden för offert
 * - Draft warning för konsulter
 * - Customer response status (godkänd/nekad)
 * 
 * @param {Object} props
 * @param {Object} props.offert - Offert-objektet
 * @param {boolean} props.isConsultantView - Om det är konsultvy
 * @param {boolean} props.isCustomerView - Om det är kundvy
 * @param {boolean} props.hasResponded - Om kunden har svarat
 */
const StatusMessages = ({ offert, isConsultantView, isCustomerView, hasResponded }) => {
  const isNewerVersion = offert?.version && parseFloat(offert.version) > 1.0;
  /**
   * Ett tillägg får egna formuleringar.
   *
   * `isNewerVersion` bygger på version inom spåret, så en tilläggsoffert på v1.0
   * hamnade i "första gången"-grenen: "Byggare bokad! Vi startar nu
   * projekteringen och planerar in projektet i kalendern" — till en kund som
   * varit i produktion i månader.
   */
  const arTillagg = arExtra(offert);
  return (
    <>
      {/* Draft warning - endast för konsulter */}
      {isConsultantView && offert.status === 'draft' && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <div className="flex items-center">
            <svg className="w-5 h-5 text-yellow-400 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 15.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
            <div>
              <h3 className="text-sm font-medium text-yellow-800">Offert i utkastläge</h3>
              <p className="text-sm text-yellow-700 mt-1">
                Denna offert är fortfarande ett utkast. Granska innehållet och klicka på "Skicka" när du är redo.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Customer response status - endast för kunder som har svarat (godkänt/nekat) */}
      {isCustomerView && hasResponded && (
        <div className={`${offert.status === 'accepted' ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'} border rounded-lg p-4 mb-6`}>
          <div className="flex items-center">
            <svg className={`w-5 h-5 ${offert.status === 'accepted' ? 'text-green-400' : 'text-red-400'} mr-3`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <h3 className={`text-sm font-medium ${offert.status === 'accepted' ? 'text-green-800' : 'text-red-800'}`}>
                {offert.status === 'accepted'
                  ? (arTillagg ? `${visaBeteckning(offert)} godkänd!` : (isNewerVersion ? 'Offert godkänd!' : 'Byggare bokad!'))
                  : (arTillagg ? `${visaBeteckning(offert)} nekad` : 'Offert nekad')}
              </h3>
              <p className={`text-sm ${offert.status === 'accepted' ? 'text-green-700' : 'text-red-700'} mt-1`}>
                {offert.status === 'accepted' && (arTillagg
                  ? 'Du har godkänt det tillkommande arbetet. Din byggkonsult har informerats och planerar in det i projektet. Din ursprungliga offert gäller fortsatt.'
                  : (isNewerVersion
                    ? 'Du har godkänt den uppdaterade offerten. Din byggkonsult har informerats.'
                    : 'Du har bokat byggaren! Vi startar nu projekteringen och planerar in projektet i kalendern. Din byggkonsult kontaktar dig för nästa steg.'
                  )
                )}
                {offert.status === 'declined' && (arTillagg
                  ? 'Du har avböjt det tillkommande arbetet. Byggkonsulten har informerats. Din ursprungliga offert påverkas inte.'
                  : 'Du har nekat offerten. Byggkonsulten har informerats om ditt beslut.'
                )}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StatusMessages;

